export default "__VITE_ASSET__d88a56c8__"